import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Components/Header/Header';

import ProductenOverzichtScreen from './Screens/admin/producten/ProductenOverzichtScreen/ProductenOverzichtScreen';
import MakenAanpassenKlasScreen from './Screens/admin/klassen/MakenAanpassenKlasScreen/MakenAanpassenKlasScreen';
import LeverancierOverzichtScreen from './Screens/admin/Leverancier/LeverancierOverzichtScreen/LeverancierOverzichtScreen';
import AllergenenScreen from './Screens/admin/AllergenenScreen/AllergenenScreen';
import KlassenOverzichtScreen from './Screens/admin/klassen/klassenOverzichtScreen/KlassenOverzichtScreen';
import MakenAanpassenMenu from './Screens/admin/Menu/MakenAanpassenMenuScreen/MakenAanpassenMenu';
import LeerkrachtScreen from './Screens/leerkracht/LeerkrachtScreen/LeerkrachtScreen';
import LeerkrachtGeschiedenisScreen from './Screens/leerkracht/LeerkrachtGeschiedenisScreen/LeerkrachtGeschiedenisScreen';
import MenuOverzichtScreen from './Screens/admin/Menu/MenuOverzichtScreen/MenuOverzichtScreen';
import MakenAanpassenProductScreen from './Screens/admin/producten/MakenAanpassenProductScreen/MakenAanpassenProductScreen';
import VoorstelScreen from './Screens/leerkracht/VoorstelScreen/VoorstelScreen';
import GebruikersBeheerScreen from './Screens/authenticatie/GebruikersbeheerScreen/GebruikersbeheerScreen'
import { PrivateRoute } from './Components/Login/PrivateRoute';
import { Role } from './Services/auth.service';
import LoginScreen from './Screens/authenticatie/LoginScreen/LoginScreen';
import UnauthorizedPage from './Screens/authenticatie/UnauthorizedPage';
import RegisterScreen from './Screens/authenticatie/RegisterScreen/RegisterScreen';
import WachtGoedkeuringScreen from './Screens/authenticatie/WachtGoedkeuringScreen/WachtGoedkeuringScreen'
import ControleVoorstelScreen from './Screens/admin/ControleVoorstelScreen/ControleVoorstelScreen';
import MakenAanpassenLeverancier from './Screens/admin/Leverancier/MakenAanpassenLeverancier/MakenAanpassenLeverancier';
import ControleBestellingScreen from './Screens/admin/ControleBestellingScreen/ControleBestellingScreen';
import PdfScreen from './Screens/admin/Pdf/pdfScreen'
import KlasTypeScreen from './Screens/admin/KlasTypeScreen/KlasTypeScreen';
import EenheidScreen from './Screens/admin/EenheidScreen/EenheidScreen';
import ProductLocatieScreen from './Screens/admin/ProductLocatieScreen/ProductLocatieScreen';
import EigenschappenScreen from './Screens/admin/EigenschappenScreen/EigenschappenScreen';
import BestellingsGeschiedenisScreen from './Screens/admin/BestelingsGeschiedenisScreen/BestellingsGeschiedenisScreen';
import VoorstelGeschiedenisScreen from './Screens/admin/VoorstelGeschiedenisScreen/VoorstelGeschiedenisScreen';
import BestelTermijnScreen from './Screens/admin/BestelTermijnScreen/BestelTermijnScreen';
import TestScherm from './Screens/testscherm/testscherm';
import BestelScreen from './Screens/admin/BestelScreen/BestelScreen';
import MFCScreen from './Screens/admin/MFCScreen/MFCScreen';
import ProfielScreen from './Screens/authenticatie/ProfielScreen/ProfielScreen';
import ExtraProductToevoegenScreen from './Screens/admin/ExtraProductToevoegenScreen/ExtraProductToevoegenScreen';
import { ConfigProvider, Pagination } from 'antd';
import AdminScreen from './Screens/admin/AdminScreen/AdminScreen';
import GeplandeLessenScreen from './Screens/leerkracht/GeplandeLessenScreen/GeplandeLessenScreen';
import PDF from './Screens/admin/Pdf/pdfScreen';

function App() {
  return (
    <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#ff5700', // Oranje kleur
      },
    }}
  >
        <Router basename='/'>
      <div className='app-container'>
        <Header className='header' />

        <div className='screen-container'>
          <Routes>
            <Route path="/" element={<LoginScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path='/registreer' element={<RegisterScreen />} />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
            <Route path='/pdf' element={<PDF/>}/>
            {/*aanvrager routes*/}
            <Route 
              path='/goedkeuring' 
              element={ <WachtGoedkeuringScreen /> }/>
            {/*leerkracht routes*/}
            <Route 
              path='/leerkracht' 
              element={
                <PrivateRoute roles={[Role.Leerkracht, Role.Besteller, Role.Gebruikersbeheerder]}>
                  <LeerkrachtScreen />
                </PrivateRoute>
              } 
            />
            <Route 
              path='/leerkracht/geschiedenis' 
              element={
                <PrivateRoute roles={[Role.Leerkracht, Role.Besteller, Role.Gebruikersbeheerder]}>
                  <LeerkrachtGeschiedenisScreen />
                </PrivateRoute>
              } 
            />
            <Route 
              path='/leerkracht/geplandelessen' 
              element={
                <PrivateRoute roles={[Role.Leerkracht, Role.Besteller, Role.Gebruikersbeheerder]}>
                  <GeplandeLessenScreen />
                </PrivateRoute>
              } 
            />
            <Route 
              path='/voorstel' 
              element={
                <PrivateRoute roles={[Role.Leerkracht, Role.Besteller, Role.Gebruikersbeheerder]}>
                  <VoorstelScreen />
                </PrivateRoute>
              } 
            />
            <Route 
              path='/profiel' 
              element={
                <PrivateRoute roles={[Role.Leerkracht, Role.Besteller, Role.Gebruikersbeheerder]}>
                  <ProfielScreen />
                </PrivateRoute>
              } 
            />
            {/*Besteller routes*/}
            {/* Admin routes met AdminLayout */}
            <Route 
              path="/Admin/configuratie" 
              element={
                <PrivateRoute roles={[Role.Besteller, Role.Gebruikersbeheerder]}>
                  <EigenschappenScreen />
                </PrivateRoute>
              }
            >
              <Route path="KlasType" element={<KlasTypeScreen />} />
              <Route path="BestelTermijn" element={<BestelTermijnScreen />} />
              <Route path="Eenheid" element={<EenheidScreen />} />
              <Route path="Locatie" element={<ProductLocatieScreen />} />
              <Route path="Eigenschappen" element={<EigenschappenScreen />} />
              <Route path='Allergenen' element={<AllergenenScreen />}/>
              <Route path='Klassen' element={<KlassenOverzichtScreen />}/>
              <Route path='Leverancier' element={<LeverancierOverzichtScreen />}/>
              <Route path='Producten' element={<ProductenOverzichtScreen />}/>
              <Route path='OverzichtMenu'element={<MenuOverzichtScreen />}/>
              <Route path='MakenAanpassenKlas' element={<MakenAanpassenKlasScreen />}/>
              <Route path='MakenAanpassenMenu' element={<MakenAanpassenMenu />}/>
              <Route path='MakenAanpassenProduct' element={<MakenAanpassenProductScreen />}/>
              <Route path='MakenAanpassenLeverancier' element={<MakenAanpassenLeverancier />}/>
            </Route>
            <Route 
              path="/Admin/bestelling" 
              element={
                <PrivateRoute roles={[Role.Besteller, Role.Gebruikersbeheerder]}>
                  <AdminScreen />
                </PrivateRoute>
              }
            >
              <Route path='ControleVoorstel' element={<ControleVoorstelScreen />}/>
              <Route path='ControleBestelling' element={<ControleBestellingScreen />}/>
              <Route path='Bestelling' element={<BestelScreen />}/>
              <Route path='BestellingsGeschiedenis' element={<BestellingsGeschiedenisScreen />}/>
              <Route path='VoorstelGeschiedenis' element={<VoorstelGeschiedenisScreen />}/>
              <Route path='Leerkracht' element={<LeerkrachtScreen />}/>
              <Route path='Voorstel' element={<VoorstelScreen />}/>
              <Route path='Geschiedenis' element={<LeerkrachtGeschiedenisScreen />}/>
              <Route path='GeplandeLessen' element={<GeplandeLessenScreen />}/>
              <Route path='MFC' element={<MFCScreen />}/>
              <Route path='extraProduct' element={<ExtraProductToevoegenScreen/>}/>
              <Route path="gebruikersbeheer" element={<GebruikersBeheerScreen />}/>
            </Route>
          </Routes>
        </div>
      </div>
    </Router>
  </ConfigProvider>

  );
}

export default App;
